<ng-container *transloco="let t">
  <div class="bg-default flex min-h-screen flex-col">
    <header
      class="bg-card flex items-center gap-3 border-b px-4 py-2"
      style="border-color: var(--fuse-border)"
    >
      <img class="h-9 w-9" src="images/logo/dentapop-app-logo.png" alt="Dentapop" />
      <div class="min-w-0 flex-auto">
        <p class="truncate font-bold text-default">{{ t('app.title') }}</p>
        <p class="text-sm text-secondary">{{ t('app.subtitle') }}</p>
      </div>
      <app-scheme-toggle />
      <app-languages />
    </header>
    <main class="flex-auto">
      <router-outlet />
    </main>
  </div>
</ng-container>
